// Shared responsive values so pages size themselves the same way at every breakpoint.

// Height of the top bar that replaces the permanent sidebar below the md breakpoint.
export const MOBILE_BAR_HEIGHT = 56;

// Padding of Layout's <main>: 10px phones, 16px tablets, 20px desktop.
export const PAGE_PADDING = { xs: 1.25, sm: 2, md: 2.5 };

// Keeps very wide screens readable without shrinking laptop layouts.
export const CONTENT_MAX_WIDTH = 1760;

// Page title row of list pages: title on the left, controls wrap underneath on phones.
export const listHeaderSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  mb: 2,
};

export const listControlsSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  minWidth: 0,
  flex: { xs: "1 1 100%", sm: "0 1 500px" },
};

// Status tab buttons wrap instead of pushing the page sideways.
export const tabRowSx = { display: "flex", flexWrap: "wrap", gap: 1, mb: 2 };

// Narrow screens scroll the grid horizontally inside its own box, never the whole page.
export const dataGridSx = {
  width: "100%",
  minWidth: 0,
  "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "hidden" },
  "& .MuiDataGrid-footerContainer": { flexWrap: "wrap" },
  "& .MuiTablePagination-toolbar": { flexWrap: "wrap", px: { xs: 0.5, sm: 2 } },
};

// Flex columns keep a readable minimum width; the grid scrolls once they no longer fit.
export const withMinWidth = (columns, minWidth = 120) =>
  columns.map((column) => ({ minWidth, ...column }));

// Form fields: one column on phones, two on tablets, four on desktops.
export const formFieldSize = { xs: 12, sm: 6, lg: 3 };
export const formGridSpacing = { xs: 2, md: 3 };

export const fileInputStyle = { display: "block", width: "100%", maxWidth: "100%" };
